import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar } from '../../material-ui/Avatar';
import { IconButton } from '../../material-ui/IconButton';
import { ListItemIcon } from '../../material-ui/List';
import { Menu, MenuItem } from '../../material-ui/Menu';
import { Typography } from '../../material-ui/Typography';
import { AppBarVersion } from '../AppBarVersion';
import { LanguageSelector } from '../../LanguageSelector/LanguageSelector';
import { New } from '../../../icons';
import ChangeUser from '../../../icons/image/ChangeUser';
import Logout from '../../../icons/image/Logout';
import Person from '../../../icons/image/Person';
import Settings from '../../../icons/image/Settings';
import { getTranslateText } from '../../../service/utils';
import { useAppBarMenu } from './useAppBarMenu';
import { useStyles } from './useStyles';

export const AppBarMenu = memo(({ onLogout }) => {
    const isCustomCompany = process.env.IS_CUSTOM_COMPANY;
    const { t: translate } = useTranslation();
    const { anchorEl, user, userList, handleChangeUser, handleClose, handleOpenMenu, handleSettingsClick, handleWhatsNew } =
        useAppBarMenu(translate);

    const classes = useStyles();

    return (
        <>
            <IconButton className={classes.icon} onClick={handleOpenMenu}>
                <Avatar className="app-bar-menu__avatar-icon" src={user.preview} icon={<Person width="30" height="30" />} />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <MenuItem className={classes.listItem}>
                    <ListItemIcon style={{ boxSizing: 'border-box' }}>
                        <Person width="24" height="24" />
                    </ListItemIcon>
                    <Typography className={classes.text}>{getTranslateText('name', user)}</Typography>
                </MenuItem>
                {userList && userList.length > 1 && (
                    <MenuItem className={classes.listItem} onClick={handleChangeUser}>
                        <ListItemIcon>
                            <ChangeUser width="24" height="24" />
                        </ListItemIcon>
                        <Typography className={classes.text}>{translate('changeUser')}</Typography>
                    </MenuItem>
                )}
                <MenuItem className={classes.listItem} onClick={handleSettingsClick}>
                    <ListItemIcon>
                        <Settings width="24" height="24" />
                    </ListItemIcon>
                    <Typography className={classes.text}>{translate('settings')}</Typography>
                </MenuItem>
                {!isCustomCompany && <LanguageSelector isMenu={true} classListItem={classes.listItem} />}
                <AppBarVersion isMenu={true} onLogout={onLogout} />
                <MenuItem className={classes.listItem} onClick={handleWhatsNew}>
                    <ListItemIcon>
                        <New width="24" height="24" />
                    </ListItemIcon>
                    <Typography className={classes.text}>{translate('labels.whatsNew')}</Typography>
                </MenuItem>
                <MenuItem className={classes.listItem} onClick={onLogout}>
                    <ListItemIcon>
                        <Logout width="24" height="24" />
                    </ListItemIcon>
                    <Typography className={classes.text}>{translate('signOut')}</Typography>
                </MenuItem>
            </Menu>
        </>
    );
});

AppBarMenu.displayName = 'AppBarMenu';
